// auth.js

export const isAuthenticaded = () => {
  return localStorage.getItem("access_token");
};

export const getUser = () => {
  return localStorage.getItem("user");
};
